import React, { Fragment, useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Header from 'components/Header';
import {
  getToken,
  getBusinessId,
  getRole,
  setPlanSubscriptionStatus,
  getPlanSubscriptionStatus,
  setBusinessPlan,
  setUserData,
  getConfirmed,
} from 'constants/localStorageManager.js';
import SocialIcons from './LandingPage/SocialIcons';
import EmailConfirmationBanner from './Banners/EmailConfirmationBanner';
import PendingCancellationBanner from './Banners/pendingCancellation';
import RenewPlanBanner from './Banners/RenewPlanBanner';

import 'assets/scss/landingPage.css';
import UsersApi from '../apis/Users';
import {
  ROUTES,
  RENEW_SUBSCRIPTION_ROUTES,
  insertBusinessIdtoUrl,
} from '../constants/Routes';
import { USERS } from '../constants/Users';
import ChargeFailedBanner from './Banners/chargeFailed';

const DashboardLayout = ({ children, location, history }) => {
  const { status } = getPlanSubscriptionStatus() || {};
  const isActive = status === 'active';
  const isPendingCancellation = status === 'pending_cancellation';
  const isActiveOrPending = isActive || isPendingCancellation;
  const [isExpiring, setIsExpiring] = useState(!isActiveOrPending || false);
  const [displayBanner, setDisplayBanner] = useState(
    !isActiveOrPending || false
  );

  const fetchUserData = async () => {
    const { data } = await UsersApi.getMyDetails();
    const { plan_subscription, plan } = data;
    const { status } = plan_subscription || {};
    const isActive = status === 'active';
    const isPendingCancellation = status === 'pending_cancellation';
    const isActiveOrPending = isActive || isPendingCancellation;
    setPlanSubscriptionStatus(plan_subscription);
    setIsExpiring(!isActiveOrPending);
    setDisplayBanner(!isActiveOrPending);
    setPlanSubscriptionStatus(plan_subscription);
    setBusinessPlan(plan);
    setUserData(data);
    if (!isActiveOrPending)
      if (
        location.pathname !== ROUTES.BUSINESS_USER_DETAIL &&
        getRole() !== USERS.ADMIN
      )
        history.push(
          insertBusinessIdtoUrl(ROUTES.BUSINESS_USER_DETAIL, getBusinessId())
        );
  };

  useEffect(() => {
    fetchUserData();
  }, [status]);

  const renewPlan = e => {
    e.preventDefault();
    history.push(RENEW_SUBSCRIPTION_ROUTES.SELECT_PLANS);
  };

  const toggleBanner = () => {
    setDisplayBanner(false);
  };

  const isAdmin = getRole() === USERS.ADMIN;

  return (
    <Fragment>
      {!isAdmin && <PendingCancellationBanner fetchUserData={fetchUserData} />}
      {!isAdmin && <ChargeFailedBanner fetchUserData={fetchUserData} />}
      <main style={!isAdmin && isExpiring ? { opacity: 0.7 } : {}}>
        <header className="main-header">
          {!isAdmin && <EmailConfirmationBanner />}
          <div className="container">
            <div>
              <Header />
            </div>
          </div>
        </header>
        <div
          className={`main-body clearfix ${
            !getConfirmed() ? 'b-active' : 'b-deactive'
          }`}
        >
          {children}
        </div>
        <footer
          className={`text-muted pt-4 pb-4 mt-5 ${
            !getConfirmed() ? 'b-active-footer' : ''
          }`}
        >
          <div className="container">
            <div className="row">
              <p className="col-lg-6 col-md-12 col-sm-12 rights-reserved">
                © {new Date().getFullYear()} All rights reserved by{' '}
                <Link to="/home">Soono</Link>.
                <SocialIcons className="col-sm-12" />
              </p>
              <p className="float-right col-lg-6 col-md-12 col-sm-12 footer-links">
                <ul>
                  <li>
                    {!getToken() ? (
                      <a href="/home#growBusiness">About Us</a>
                    ) : null}
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-of-use">Terms and Conditions</Link>
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </footer>
      </main>
      {!isAdmin && (
        <RenewPlanBanner
          isVisible={displayBanner}
          toggleBanner={toggleBanner}
          renewPlan={renewPlan}
        />
      )}
    </Fragment>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.shape({}).isRequired,
};

export default withRouter(DashboardLayout);



// WEBPACK FOOTER //
// ./src/components/DashboardLayout.js